export default __webpack_public_path__ + "static/media/View of some seating for meals and breaks.a5ee3914.jpg";